import React from "react";

import {
  CURRENT_DONE,
  progressLabel,
  STEP_KEYS,
  STEP_LABELS,
  stateLabel,
  stepTone,
} from "@/steps";

const TONE_CLASSES = {
  done: "bg-green-600",
  current: "bg-primary ring-2 ring-primary/25",
  todo: "border border-muted-foreground/40 bg-muted",
  error: "bg-destructive",
};

export default function StepDots({ steps, size = "sm" }) {
  const hasCompleteSteps = Boolean(
    steps &&
      STEP_KEYS.every((key) => steps[key]?.state) &&
      (STEP_KEYS.includes(steps.current) || steps.current === CURRENT_DONE)
  );
  const availableSteps = hasCompleteSteps ? steps : undefined;
  const sizeClass = size === "md" ? "h-3 w-3" : "h-2.5 w-2.5";

  const dotProps = (key) => {
    const step = availableSteps?.[key];
    const tone = stepTone(key, step, availableSteps?.current);
    return {
      "data-tone": tone,
      title: `${STEP_LABELS[key]} · ${stateLabel(key, step)}`,
      className: `inline-block shrink-0 rounded-full ${sizeClass} ${TONE_CLASSES[tone]}`,
    };
  };

  const currentLabel = progressLabel(availableSteps);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-1.5" aria-label="Avancement du dossier">
        <span data-testid="step-formulaire" {...dotProps("formulaire")} />
        <span data-testid="step-interview" {...dotProps("interview")} />
        <span data-testid="step-recit" {...dotProps("recit")} />
        <span data-testid="step-bd" {...dotProps("bd")} />
        <span data-testid="step-minisite" {...dotProps("minisite")} />
      </div>
      {size === "md" && (
        <p className="text-sm text-muted-foreground">{currentLabel}</p>
      )}
    </div>
  );
}
